var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuPontIconEnvironmentalResistanceRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64.6 78.6",
    style: {
      enableBackground: "new 0 0 64.6 78.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E4001C;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.6,13.9c-8.8,0-27.8-9-30.5-12.8L32.3,0l-0.8,1.2C28.7,5.1,8.8,13.9,1,13.9H0v32.3 c0,15.5,30.4,31.8,32.1,32.3l0.3,0.1l0.3-0.1c1.4-0.4,32.1-17.9,32.1-30.6v-34H63.6z M62.6,47.9c0,10.7-26.6,27-30.3,28.6 C29,75,2,59.7,2,46.2V15.9C10.1,15.3,27.5,8,32.3,3.2c4.8,4.7,21.5,12.1,30.3,12.6V47.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.4,28.1C28.8,28,28.2,28,27.6,28c-6.1,0-11.2,4.5-11.9,10.3C12,38.3,9,41.3,9,45.1C9,48.9,12,52,15.8,52 h24.4h0c4.8,0,8.7-3.9,8.7-8.7c0-2.6-1.1-4.9-2.9-6.5c1.5-1.7,2.3-3.9,2.3-6.2c0-5.3-4.3-9.6-9.6-9.6C34.3,21,30.5,23.9,29.4,28.1z  M46.9,43.3c0,3.7-3,6.7-6.7,6.7H15.8c-2.7,0-4.9-2.2-4.9-4.9s2.2-4.9,4.9-4.9h0c0.2,0,0.5,0,0.7,0l1,0.1l0-1.1 c0.2-5.3,4.6-9.4,10-9.4c4.3,0,8,2.5,9.4,6.4l0.3,0.9l0.9-0.3c0.6-0.2,1.2-0.3,2-0.3C43.9,36.7,46.9,39.7,46.9,43.3z M38.7,23 c4.2,0,7.6,3.4,7.6,7.6c0,1.9-0.7,3.7-1.9,5.1c-1.2-0.7-2.6-1-4.1-1c-0.6,0-1.2,0-1.7,0.2c-1.4-3.1-4-5.3-7.2-6.3 C32.3,25.3,35.2,23,38.7,23z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.4,
    y: 56.4,
    transform: "matrix(0.4912 -0.871 0.871 0.4912 -32.8653 58.5031)",
    className: "st0",
    width: 8.6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.1,
    y: 56.4,
    transform: "matrix(0.4912 -0.871 0.871 0.4912 -39.107 47.8358)",
    className: "st0",
    width: 8.5,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.4,
    y: 61.2,
    transform: "matrix(0.4912 -0.871 0.871 0.4912 -41.5273 53.3448)",
    className: "st0",
    width: 11.1,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.9,
    y: 22.8,
    transform: "matrix(0.4064 -0.9137 0.9137 0.4064 -7.8104 37.4393)",
    className: "st0",
    width: 2,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.3,
    y: 35,
    transform: "matrix(0.4064 -0.9137 0.9137 0.4064 -2.6841 69.7417)",
    className: "st0",
    width: 2,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.8,
    y: 16.7,
    transform: "matrix(0.808 -0.5892 0.5892 0.808 -5.2959 21.1352)",
    className: "st0",
    width: 2,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.1,
    y: 13.9,
    transform: "matrix(0.9951 -9.845074e-02 9.845074e-02 0.9951 -1.3836 3.734)",
    className: "st0",
    width: 2,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.8,
    y: 16.1,
    transform: "matrix(0.4061 -0.9138 0.9138 0.4061 10.9304 51.0241)",
    className: "st0",
    width: 3.9,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.8,
    y: 21,
    transform: "matrix(0.8082 -0.5889 0.5889 0.8082 -3.2177 34.1103)",
    className: "st0",
    width: 3.9,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.6,
    y: 28.4,
    transform: "matrix(0.9951 -9.862036e-02 9.862036e-02 0.9951 -2.6338 5.4256)",
    className: "st0",
    width: 3.9,
    height: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuPontIconEnvironmentalResistanceRed);
export default __webpack_public_path__ + "static/media/DuPont_Icon_Environmental_Resistance_red.247a5602cf2717fa883183f29f628187.svg";
export { ForwardRef as ReactComponent };